import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const HeartSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.8 4a5.23 5.23 0 0 0-2.89.878A5.17 5.17 0 0 0 12 7.204a5.17 5.17 0 0 0-1.913-2.328A5.23 5.23 0 0 0 7.194 4C4.326 4 2 6.84 2 9.694 2 15.93 10.666 21 12 21s10-5.07 10-11.306C22 6.84 19.674 4 16.8 4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(HeartSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
